import*as e from"react";const t=e.createContext();"production"!==process.env.NODE_ENV&&(t.displayName="TableContext");var o=t;export{o as T};
